// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1GXPq","content":"GlobalSearch_content__298pH"};